import { GenericFormItemStyle } from './styles';

const GenericFormItem = ({ ...props }: any) => {
  return <GenericFormItemStyle {...props} />;
};

export default GenericFormItem;
